




import { Component, Vue } from 'vue-property-decorator';
import EventBus from '@/event-bus';

import { ConstantsModuleMapper } from '@/store/modules/constants';

const Mappers = Vue.extend({
  computed: {
    ...ConstantsModuleMapper.mapGetters(['zadarmaCallDictionary']),
  },
});

@Component
export default class ZadarmaClickToCall extends Mappers {
  mounted() {
    const trigger = document.querySelector('#zadarmaCall');
    if (trigger) {
      const Widget_ID = 'myZadarmaCallmeWidget15210';
      const Widget = window.ZadarmaCallmeWidget;
      if (!Widget) {
        return;
      }
      window[Widget_ID] = new Widget(Widget_ID);
      window[Widget_ID].create({
        widgetId: 'Pr4m2jruXMeC18sbBp22Fab6UVbtL5SbjuVF452r5ya4Zjghy9pkuey1ZYt3zge4tKgXJ2jvgb1zyy8r1RC2m2RhacTtSRz80d13b943c8db3b2b67efa7bc70cc5404',
        sipId: '381015',
        domElement: 'zadarmaCall',
      }, {
        shape: 'square',
        language: 'custom',
      });
      const zadarmaCallDictionary = {
        txt_greeting: this.$t(this.zadarmaCallDictionary.txt_greeting, this.$i18n.locale) as string,
        txt_nowebrtc: this.$t(this.zadarmaCallDictionary.txt_nowebrtc, this.$i18n.locale) as string,
        texts: {} as Record<string, string>,
      };
      Object
        .keys(this.zadarmaCallDictionary.texts)
        .forEach((item: string) => {
          zadarmaCallDictionary.texts[item] = this.$t(this.zadarmaCallDictionary.texts[item], this.$i18n.locale) as string;
        });
      window[Widget_ID].zadarmaCreate(zadarmaCallDictionary);
    }
    EventBus.$on('callback', () => {
      if (trigger) {
        (trigger as HTMLElement).dispatchEvent(new Event('mousedown'));
      }
    });
  }
}
